<template>
  <table class="mx-auto table-border page">
    <thead>
      <tr>
        <th>STT</th>
        <th>Số phòng</th>
        <th>SĐT</th>
        <th>Ngày đặt cọc</th>
        <th>Ngày hẹn nhận phòng</th>
        <th>Tình trạng phòng</th>
        <th>Tình trạng cọc</th>
        <th>Giá phòng</th>
        <th>Giá cọc</th>
        <th>Tổng cộng</th>
        <th>Tiền đã đóng</th>
        <th>Tiền còn thiếu</th>
        <th>Mã quản lý</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(room_data, index) in items" :key="room_data.room_id">
        <td class="text-center">{{ index + 1 }}</td>
        <td class="text-center">{{ room_data.room_id }}</td>
        <td class=" text-no-wrap">{{ room_data.phone }}</td>
        <td class=" text-no-wrap">
          {{ room_data.date_deposit | formatTimeServer }}
        </td>
        <td class="text-center text-no-wrap">
          {{ room_data.date_schedule_in | formatTimeServer }}
        </td>
        <td class=" text-no-wrap">{{ room_status[room_data.room_status] }}</td>
        <td class=" text-no-wrap">
          <span
            :class="[
              'v-badge',
              room_data.deposit_status ? 'primary' : 'warning',
            ]"
          >
            {{ room_data.deposit_status ? "Đã cọc đủ" : "Chưa cọc đủ" }}
          </span>
        </td>
        <td class="">{{ room_data.room_price | formatNumber }}</td>
        <td class="">{{ room_data.deposit_price | formatNumber }}</td>
        <td class="">{{ room_data.total_price | formatNumber }}</td>
        <td class="">{{ room_data.collected_amount | formatNumber }}</td>
        <td class="">{{ room_data.debt | formatNumber }}</td>
        <td class=" text-no-wrap">{{ room_data.room_state_id }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { room_status } from 'Constants/db-config' 

export default {
  name: "print-bang-thep-doi-coc",
  props: {
    items: { type: Array, default: [] },
  },
  data() {
    return {
      room_status,
    };
  },
};
</script>

<style></style>
